import React, { useState, useEffect } from "react";
import { baseUrl } from "../../utils/apiActions/dashboardApi";

const Support = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [pendingPayments, setPendingPayments] = useState([]); 
  const [newPayments, setNewPayments] = useState([]); 
  const [pendingPaymentCounts, setPendingPaymentCounts] = useState(0);
  const [newPaymentCounts, setNewPaymentCounts] = useState(0);

  const fetchNewPayments = () => {
    const url = `${baseUrl}/payments/collections?statusId=0`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setNewPayments(res); // Set fetched payments
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchPendingPayments = () => {
    const url = `${baseUrl}/payments/collections?statusId=1`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setPendingPayments(res); // Set fetched payments
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchNewPayments();
    fetchPendingPayments();
    const interval = setInterval(() => {
      fetchNewPayments();
      fetchPendingPayments();
    }, 120000); 

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   const newPaymentsLength = newPayments.length;
  //   const pendingPaymentsLength = pendingPayments.length;

  //   // Count for new payments
  //   if (newPaymentsLength > 0) {
  //     const intervalNew = setInterval(() => {
  //       setNewPaymentCounts((prevCount) => {
  //         if (prevCount < newPaymentsLength) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(intervalNew);
  //           return prevCount;
  //         }
  //       });
  //     }, 150); 

  //     return () => clearInterval(intervalNew);
  //   }

  //   // Count for pending payments
  //   if (pendingPaymentsLength > 0) {
  //     const intervalPending = setInterval(() => {
  //       setPendingPaymentCounts((prevCount) => {
  //         if (prevCount < pendingPaymentsLength) {
  //           return prevCount + 1;
  //         } else {
  //           clearInterval(intervalPending);
  //           return prevCount;
  //         }
  //       });
  //     }, 150); 

  //     return () => clearInterval(intervalPending);
  //   }
  // }, [newPayments, pendingPayments]);

  return (
    <div
      className='d-flex m-10 p-10'
      style={{ marginTop: "10%", marginLeft: "5%", marginRight: "5%", gap: 10 }}
    >
      <div className='card w-50'>
        <h6>New Payments</h6>
        <h1 style={{ color: newPayments?.length < 49 ? "#20c997" : "#dc3545" }}>
          {newPayments?.length}
        </h1>
      </div>
      <div className='card w-50'>
        <h6>Pending Payments</h6>
        <h1
          style={{
            color: pendingPayments?.length < 49 ? "#20c997" : "#dc3545",
          }}
        >
          {pendingPayments?.length}
        </h1>
      </div>
    </div>
  );
};

export default Support;
